export default __webpack_public_path__ + "static/media/p10.14148085.jpg";